import * as moment from "moment";

export class DayPartHelper {

    public static getCurrentDayPart(): string {

        const m = moment();

        if(!m || !m.isValid()) { return; } //if we can't find a valid or filled moment, we return.
	
        const split_afternoon = 12 //24hr time to split the afternoon
        const split_evening = 17 //24hr time to split the evening
        const currentHour = parseFloat(m.format("HH"));
        
        let part = 'Morning';

        if(currentHour >= split_afternoon && currentHour < split_evening) {
            part = "Afternoon";
        } else if(currentHour >= split_evening) {
            part = "Evening";
        } else {
            part = "Morning";
        }
        
        return part;
    }

}